(function() {

  // PLP & PDP wishlist elements
  let __wishlistObserverLoaded = false;
  let __wishlistDebounce;

  function dispatchWishlistEvent() {
    clearTimeout(__wishlistDebounce);

    __wishlistDebounce = setTimeout(() => {
      if (window.Wishlist && typeof Wishlist.init === 'function') {
        Wishlist.init();
      }
      if (window.theWishlist) {
        document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
      } else {
        setTimeout(dispatchWishlistEvent, 150); // retry until theWishlist is ready
      }
    }, 150);
  }

  function waitForSearchspringAndObserve() {
    const results = document.querySelector('.product-list');

    if (!results) {
      setTimeout(waitForSearchspringAndObserve, 200);
      return;
    }

    // Do not initialize twice
    if (__wishlistObserverLoaded) return;
    __wishlistObserverLoaded = true;

    const parent = results.parentNode;
    if (!parent || parent.nodeType !== 1) return;

    const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {

      const addedNodes = [...mutation.addedNodes];
        if (addedNodes.some(n =>
          n.nodeType === 1 &&
          (n.classList?.contains('product-item') ||
          n.classList?.contains('product-item ') ||
          n.classList?.contains('product-list'))
        )) {
          dispatchWishlistEvent();
          break;
        }
      }
    });

    observer.observe(parent, {
      childList: true,
      subtree: true
      });
  }

  window.addEventListener('load', () => {
    dispatchWishlistEvent();
    waitForSearchspringAndObserve();
  }); 

// Coming soon
document.addEventListener("DOMContentLoaded", function () {
  const TENANT_ID = "kat-the-label";
  console.log(TENANT_ID, "TWC init");

  const TOKEN_URL =
    `https://2hrfu2sis6cfjbslmkh6aslv7e0zpesc.lambda-url.ap-southeast-2.on.aws?tenant_id=${TENANT_ID}`;

  async function getAccessToken() {
    try {
      const response = await fetch(TOKEN_URL, { method: "POST" });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      return (await response.json()).access_token;
    } catch (error) {
      console.error("Error fetching access token:", error);
      return null;
    }
  }

  // Inject popup once
  function injectPopup() {
    if (document.querySelector("#popup-body")) return;

    const _customerEmail = window.customerEmail || "";
    const popupHtml = `
      <div id="popup-body" class="overlay notify-coming" style="display:none;">
        <div id="popup-wrapper">
          <h2 id="popup-title" class="heading h3 content-box--text-center">Register Your Interest</h2>
          <span id="popup-close">&times;</span>

          <div id="popup-text" class="content-box--text-center">
            Enter your email address and we will notify you when the item becomes available.
          </div>

          <div id="popup-message" class="content-box--text-center"></div>

          <form id="popup-form">
            <h4 id="popup-product-title" class="heading h6"></h4>

            <!-- ✅ Option groups render here -->
            <div class="variant-groups" data-variant-groups></div>

            <!-- ✅ final matched variant id -->
            <input type="hidden" name="variantRef" value="" />

            <!-- ✅ which flow opened the popup: coming-soon | notify-me -->
            <input type="hidden" name="interestType" value="coming-soon" />

            <input name="firstName" placeholder="First Name" type="text" required />
            <input name="email" placeholder="Email address" type="email" class="email" required value="${_customerEmail}">
            <input name="mobile" placeholder="Mobile number" type="tel" required />

            <button type="submit" class="submit-notify email-sub-button subscribe-button button button--primary">Submit</button>

            <div id="checkbox-wrapper">
              <input type="checkbox" name="mailList" id="mailList" checked>
              <label for="mailList">Subscribe to our mailing list.</label>
            </div>
          </form>
        </div>
      </div>`;
    document.body.insertAdjacentHTML("beforeend", popupHtml);
  }

  // Build: option groups UI + resolve final variant id (OOS only)
  function fetchAndPopulateVariants(productHandle, selectedVariantId, productTitle, interestType) {
    fetch(`/products/${productHandle}.js`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
        return r.json();
      })
      .then((product) => {
        const popup = document.querySelector("#popup-body");
        const form = document.querySelector("#popup-form");
        const groupsEl = document.querySelector("[data-variant-groups]");
        const titleEl = document.querySelector("#popup-form #popup-product-title");
        const hiddenVariantRef = form.querySelector("input[name='variantRef']");
        const interestTypeInput = form.querySelector('input[name="interestType"]');

        if (interestTypeInput) {
          interestTypeInput.value = interestType || "coming-soon";
        }

        // Reset title + text every open (since we hide text on success)
        const popupTitleEl = document.querySelector("#popup-title");
        const popupTextEl = document.querySelector("#popup-text");
        if (popupTitleEl) {
          popupTitleEl.textContent =
            interestType === "notify-me"
              ? "Notify Of Restock"
              : "Register Your Interest";
        }
        if (popupTextEl) popupTextEl.style.display = "";

        if (titleEl) titleEl.textContent = productTitle || product.title || "";
        if (!groupsEl) return;

        groupsEl.innerHTML = "";
        hiddenVariantRef.value = "";

        // Only OUT OF STOCK variants are eligible
        const oosVariants = (product.variants || []).filter((v) => !v.available);

        if (!oosVariants.length) {
          groupsEl.innerHTML = `<p class="no-variants">No out-of-stock sizes available</p>`;
          popup.style.display = "flex";
          popup.classList.add("active");
          return;
        }

        // ✅ Option names (safe)
        const optionNamesRaw = product.options || [];
        const optionNames = optionNamesRaw.map((o) => {
          if (typeof o === "string") return o;
          if (o && typeof o === "object") return o.name || o.label || "";
          return "";
        });

        // Map key "opt1||opt2||opt3" -> variant.id (only OOS)
        const variantMap = new Map();
        oosVariants.forEach((v) => {
          const key = [v.option1, v.option2, v.option3].filter(Boolean).join("||");
          variantMap.set(key, String(v.id));
        });

        // Collect unique values per option index from OOS variants
        const optionValues = [new Set(), new Set(), new Set()];
        oosVariants.forEach((v) => {
          if (v.option1) optionValues[0].add(v.option1);
          if (v.option2) optionValues[1].add(v.option2);
          if (v.option3) optionValues[2].add(v.option3);
        });

        // Render one group (like Shopify option pickers)
        function renderGroup(index) {
          const values = Array.from(optionValues[index]);
          if (!values.length) return;

          const group = document.createElement("div");
          group.className = "variant-group";
          group.dataset.optionIndex = String(index);

          const heading = document.createElement("div");
          const rawTitle = optionNames[index];
          heading.className = "variant-group__title";
          heading.textContent = String(rawTitle || `Option ${index + 1}`).toUpperCase();
          group.appendChild(heading);

          const list = document.createElement("div");
          list.className = "variant-item-list";

          values.forEach((val) => {
            const label = document.createElement("label");
            label.className = "variant-item";
            label.innerHTML = `
              <input type="radio" name="opt${index + 1}" value="${val}">
              <span>${val}</span>
            `;
            list.appendChild(label);
          });

          group.appendChild(list);
          groupsEl.appendChild(group);
        }

        renderGroup(0);
        renderGroup(1);
        renderGroup(2);

        // Pre-select options based on selectedVariantId
        const selectedVariant = selectedVariantId
          ? (product.variants || []).find((v) => String(v.id) === String(selectedVariantId))
          : null;

        if (selectedVariant) {
          const opt1 = selectedVariant.option1;
          const opt2 = selectedVariant.option2;
          const opt3 = selectedVariant.option3;

          if (opt1) form.querySelector(`input[name="opt1"][value="${CSS.escape(opt1)}"]`)?.click();
          if (opt2) form.querySelector(`input[name="opt2"][value="${CSS.escape(opt2)}"]`)?.click();
          if (opt3) form.querySelector(`input[name="opt3"][value="${CSS.escape(opt3)}"]`)?.click();
        }

        function resolveVariantRef() {
          const v1 = form.querySelector('input[name="opt1"]:checked')?.value || "";
          const v2 = form.querySelector('input[name="opt2"]:checked')?.value || "";
          const v3 = form.querySelector('input[name="opt3"]:checked')?.value || "";

          const parts = [];
          if (optionValues[0].size) parts.push(v1);
          if (optionValues[1].size) parts.push(v2);
          if (optionValues[2].size) parts.push(v3);

          if (parts.some((p) => !p)) {
            hiddenVariantRef.value = "";
            return;
          }

          const key = parts.join("||");
          hiddenVariantRef.value = variantMap.get(key) || "";
        }

        function updateDisabled() {
          const v1 = form.querySelector('input[name="opt1"]:checked')?.value || "";
          const v2 = form.querySelector('input[name="opt2"]:checked')?.value || "";
          const v3 = form.querySelector('input[name="opt3"]:checked')?.value || "";

          [1, 2, 3].forEach((optNum, idx) => {
            const radios = form.querySelectorAll(`input[name="opt${optNum}"]`);
            if (!radios.length) return;

            radios.forEach((r) => {
              const test1 = idx === 0 ? r.value : v1;
              const test2 = idx === 1 ? r.value : v2;
              const test3 = idx === 2 ? r.value : v3;

              const parts = [];
              if (optionValues[0].size) parts.push(test1);
              if (optionValues[1].size) parts.push(test2);
              if (optionValues[2].size) parts.push(test3);

              const otherMissing = parts.some((p) => !p);
              if (otherMissing) {
                r.disabled = false;
                r.closest(".variant-pill")?.classList.remove("is-disabled");
                return;
              }

              const key = parts.join("||");
              const ok = variantMap.has(key);

              r.disabled = !ok;
              r.closest(".variant-pill")?.classList.toggle("is-disabled", !ok);

              if (r.checked && !ok) r.checked = false;
            });
          });
        }

        form.querySelectorAll('input[name^="opt"]').forEach((inp) => {
          inp.addEventListener("change", () => {
            updateDisabled();
            resolveVariantRef();
          });
        });

        updateDisabled();
        resolveVariantRef();

        popup.style.display = "flex";
        popup.classList.add("active");
      })
      .catch((e) => console.error("Error fetching product variants:", e));
  }

  function openPopup(productHandle, selectedVariantId, productTitle, interestType) {
    fetchAndPopulateVariants(productHandle, selectedVariantId, productTitle, interestType);
  }

  function closePopup() {
    const popup = document.querySelector("#popup-body");
    if (!popup) return;

    const form = popup.querySelector("#popup-form");
    const groupsEl = popup.querySelector("[data-variant-groups]");
    const popupMessage = popup.querySelector("#popup-message");
    const popupTextEl = popup.querySelector("#popup-text");
    const popupTitleEl = popup.querySelector("#popup-title");

    if (groupsEl) groupsEl.innerHTML = "";
    form.querySelector('input[name="variantRef"]').value = "";

    // reset the flow back to the coming-soon default
    const interestTypeInput = form.querySelector('input[name="interestType"]');
    if (interestTypeInput) interestTypeInput.value = "coming-soon";

    // reset fields
    ["email", "firstName", "mobile"].forEach((n) => {
      const el = form.querySelector(`input[name="${n}"]`);
      if (el) el.value = "";
    });

    if (popupMessage) popupMessage.innerText = "";
    form.style.display = "flex";

    // restore title/text for next open
    if (popupTitleEl) popupTitleEl.textContent = "Register Your Interest";
    if (popupTextEl) popupTextEl.style.display = "";

    popup.style.display = "none";
    popup.classList.remove("active");
  }

  function attachButtonListeners() {
    document.querySelectorAll(".twc-notifyme").forEach((button) => {
      button.addEventListener("click", function (e) {
        // prevent theme accordion / drawer scripts from interfering
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const productHandle = button.getAttribute("data-handle");
        const selectedVariantId = button.getAttribute("data-variant-id");
        const productTitle = button.getAttribute("data-product-title");
        const interestType = button.getAttribute("data-type") || "coming-soon";

        if (productHandle) {
          openPopup(productHandle, selectedVariantId, productTitle, interestType);
        }
      });
    });
  }

  document.body.addEventListener("click", function (event) {
    if (event.target.id === "popup-close") closePopup();
  });

  document.body.addEventListener("click", function (event) {
    const popupWrapper = document.querySelector("#popup-wrapper");
    if (popupWrapper && !popupWrapper.contains(event.target) && event.target.closest("#popup-body")) {
      closePopup();
    }
  });

  // Submit
  document.body.addEventListener("submit", async function (event) {
    if (event.target.id !== "popup-form") return;

    event.preventDefault();
    const form = event.target;
    const popupMessage = document.querySelector("#popup-message");
    popupMessage.innerText = "";

    const variantRef = form.querySelector('input[name="variantRef"]').value;
    const interestType =
      form.querySelector('input[name="interestType"]')?.value || "coming-soon";

    const formData = {
      email: form.querySelector("input[name='email']").value,
      firstName: form.querySelector("input[name='firstName']").value,
      mobile: form.querySelector("input[name='mobile']").value,
      variantRef,
      notifyMe: interestType === "notify-me",
      comingSoon: interestType === "coming-soon",
      subscribe: form.querySelector("input[name='mailList']")?.checked || false
    };

    if (!formData.variantRef) {
      popupMessage.innerText = "Please select a size.";
      popupMessage.style.opacity = 1;
      return;
    }

    const ACCESS_TOKEN = await getAccessToken();
    if (!ACCESS_TOKEN) {
      popupMessage.innerText = "Could not authenticate. Please try again.";
      popupMessage.style.opacity = 1;
      return;
    }

    const url = `https://api.au-aws.thewishlist.io/services/wsservice/api/wishlist/items/customerInterest`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": "Bearer " + ACCESS_TOKEN,
        "X-Twc-Tenant": TENANT_ID
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(`Server Error: ${text}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("API Response Data:", data);

        // ✅ On success: remove/hide popup text and change title to Thank You
        const popupTitleEl = document.querySelector("#popup-title");
        const popupTextEl = document.querySelector("#popup-text");
        if (popupTitleEl) popupTitleEl.textContent = "Thank You";
        if (popupTextEl) popupTextEl.style.display = "none";

        popupMessage.innerText = "Your notification has been registered.";
        popupMessage.style.opacity = 1;
        form.style.display = "none";
        setTimeout(closePopup, 3000);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        popupMessage.innerText = "Form submission failed: " + error.message;
        popupMessage.style.opacity = 1;
        setTimeout(closePopup, 3000);
      });
  });

  // Init
  injectPopup();
  attachButtonListeners();
});

// PDP button toggle
(function initRegisterInterestToggle() {
  const registerWrap = document.querySelector("[data-register-interest]");
  const registerBtn = registerWrap?.querySelector(".twc-notifyme"); // ✅ correct
  const addToCartBtn = document.querySelector("#AddToCart");

  if (!registerWrap || !registerBtn || !addToCartBtn) return;

  const allowRegister = String(registerWrap.getAttribute("data-allow-register")) === "true";
  if (!allowRegister) return;

  const formEl = registerBtn.closest("form"); // ✅ correct
  if (!formEl) return;

  const getVariantEl = () =>
    formEl.querySelector('select[name="id"]') || formEl.querySelector('input[name="id"]');

  // Theme helper button (2-option incomplete selection)
  const getSelectSizesButtons = () =>
    Array.from(formEl.querySelectorAll('button.button--select-both[type="button"]'))
      .filter((b) => !b.closest("[data-register-interest]")); // exclude Register

  const handle = registerBtn.getAttribute("data-handle"); // ✅ correct
  if (!handle) return;

  let availabilityMap = null;

  const setDisplay = (el, show) => {
    if (!el) return;
    el.style.display = show ? "" : "none";
  };

  const getSelectedVariantId = () => {
    const el = getVariantEl();
    return el ? String(el.value || "") : "";
  };

  const isSelectSizesVisible = () => {
    const btns = getSelectSizesButtons();
    if (!btns.length) return false;
    return btns.some((b) => {
      const style = window.getComputedStyle(b);
      return style.display !== "none" && style.visibility !== "hidden";
    });
  };

  function applyToggle() {
    if (!availabilityMap) return;

    const variantId = getSelectedVariantId();

    // If the theme is showing "SELECT YOUR SIZES", don't show Register
    if (isSelectSizesVisible()) {
      setDisplay(registerWrap, false);
      setDisplay(addToCartBtn, false); // let theme helper be the CTA
      return;
    }

    if (!variantId) {
      setDisplay(registerWrap, false);
      setDisplay(addToCartBtn, true);
      return;
    }

    const isAvailable = availabilityMap.get(variantId) === true;

    if (isAvailable) {
      // In stock
      setDisplay(registerWrap, false);
      setDisplay(addToCartBtn, true);

      // allow theme helper if it wants it
      getSelectSizesButtons().forEach((b) => (b.style.display = ""));
    } else {
      // Out of stock (selected)
      setDisplay(registerWrap, true);
      setDisplay(addToCartBtn, false);

      // hide theme helper while register is visible
      getSelectSizesButtons().forEach((b) => (b.style.display = "none"));

      // ensure popup opens with current selected variant
      registerBtn.setAttribute("data-variant-id", variantId);
    }
  }

  // Load product JSON (all variants)
  fetch(`/products/${handle}.js`)
    .then((r) => r.json())
    .then((product) => {
      availabilityMap = new Map();
      (product.variants || []).forEach((v) => {
        availabilityMap.set(String(v.id), !!v.available);
      });

      // initial
      applyToggle();

      // observe variant changes
      const bindVariantWatcher = () => {
        const variantEl = getVariantEl();
        if (!variantEl) return;

        // change event
        variantEl.addEventListener("change", applyToggle);

        // attribute mutation
        const mo = new MutationObserver(applyToggle);
        mo.observe(variantEl, { attributes: true, attributeFilter: ["value"] });
      };

      bindVariantWatcher();

      // theme DOM swaps / rerenders
      document.addEventListener("change", applyToggle);
      document.addEventListener("variant:change", applyToggle);
      document.addEventListener("variantChange", applyToggle);

      // delayed re-checks (covers quick-buy / payment container swaps)
      setTimeout(applyToggle, 150);
      setTimeout(applyToggle, 400);
      setTimeout(applyToggle, 900);
    })
    .catch((e) => console.error("Register toggle: failed to load product JSON", e));
})();

// PDP "Notify Me" button toggle (back-in-stock flow)
(function initNotifyMeButton() {
  const start = () => {
    const notifyBtn = document.querySelector('.twc-notifyme[data-type="notify-me"][data-coming="true"]');
    if (!notifyBtn) return;

    const handle = notifyBtn.getAttribute("data-handle");
    const formEl = notifyBtn.closest("form") || document;

    const getVariantEl = () =>
      formEl.querySelector('select[name="id"]') || formEl.querySelector('input[name="id"]');

    // Prefer an inline variants payload if the theme renders one, otherwise fetch it
    const loadVariants = () => {
      const variantsEl = document.querySelector('script[id^="ProductVariants-"]');
      if (variantsEl) {
        try {
          const parsed = JSON.parse(variantsEl.textContent);
          return Promise.resolve(Array.isArray(parsed) ? parsed : parsed.variants || []);
        } catch (e) {
          console.error("Notify me: could not parse variants JSON", e);
        }
      }
      if (!handle) return Promise.resolve([]);
      return fetch(`/products/${handle}.js`)
        .then((r) => r.json())
        .then((product) => product.variants || []);
    };

    loadVariants()
      .then((variants) => {
        if (!variants.length) return;

        const applyNotifyToggle = () => {
          const el = getVariantEl();
          const variantId = el ? String(el.value || "") : "";
          if (!variantId) return;

          const variant = variants.find((v) => String(v.id) === variantId);
          if (!variant) return;

          notifyBtn.setAttribute("data-variant-id", variantId);
          notifyBtn.style.setProperty("display", variant.available ? "none" : "block", "important");
        };

        applyNotifyToggle();

        const variantEl = getVariantEl();
        if (variantEl) {
          variantEl.addEventListener("change", applyNotifyToggle);
          const mo = new MutationObserver(applyNotifyToggle);
          mo.observe(variantEl, { attributes: true, attributeFilter: ["value"] });
        }

        document.addEventListener("change", applyNotifyToggle);
        document.addEventListener("variant:change", applyNotifyToggle);
        document.addEventListener("variantChange", applyNotifyToggle);

        setTimeout(applyNotifyToggle, 150);
        setTimeout(applyNotifyToggle, 400);
        setTimeout(applyNotifyToggle, 900);
      })
      .catch((e) => console.error("Notify me: failed to load product JSON", e));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

})();